import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { UserService, AlertService } from "../services";
import {
    AccCategoryE,
    InsuranceFileE,
    FileMaintenance1E, ElectronicSignatureE, DMSE, LabelE
} from "../models";
import { MsgConfig } from "..";
import { BasePrivGetter } from "./access-privs.guard";

@Injectable()
export class InsuranceFileAddGuard extends BasePrivGetter
     {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.InsuranceFile, InsuranceFileE.Add, true);
        return reslt;
    }
}

@Injectable()
export class InsuFileChangeGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.InsuranceFile, InsuranceFileE.Edit, true);
        return reslt;
    }
}
@Injectable()
export class PrescriberNotesGuard extends BasePrivGetter
     {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.FileMaintenance1, FileMaintenance1E.PrescriberNotesLog, true);
        return reslt;
    }
}

@Injectable()
export class PatientNotesGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.FileMaintenance1, FileMaintenance1E.PatientNotesLog, true);
        return reslt;
    }
}

@Injectable()
export class DrugNotesGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.FileMaintenance1, FileMaintenance1E.DrugNotesLog, true);
        return reslt;
    }
}

@Injectable()
export class InsuranceNotesGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.FileMaintenance1, FileMaintenance1E.InsuranceNotesLog, true);
        return reslt;
    }
}

@Injectable()
export class RphVerifyGuard  {
    constructor(private _userServ: UserService, private _alertServ: AlertService) {}

    canActivate() {
        const techName = this._userServ.getToken("TechUserName");
        if (!techName) {
            return true;
        } else {
            this._alertServ.error(MsgConfig.NO_PRIVS_ACCESS);
            return false;
        }
    }
}

@Injectable()
export class SigByPatientGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.ElectronicSignature, ElectronicSignatureE.SignatureByPatient, true);
        return reslt;
    }
}
@Injectable()
export class SignatureByDateGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.ElectronicSignature, ElectronicSignatureE.SignatureByDate, true);
        return reslt;
    }
}
@Injectable()
export class SignatureByRxGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.ElectronicSignature, ElectronicSignatureE.SignatureByRx, true);
        return reslt;
    }
}
@Injectable()
export class HIPAAAckgGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.ElectronicSignature, ElectronicSignatureE.HIPAAAcknowledgement, true);
        return reslt;
    }
}
@Injectable()
export class PrintRxPickUpLogGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.ElectronicSignature, ElectronicSignatureE.PrintRxPickupLog, true);
        return reslt;
    }
}
@Injectable()
export class SignatureClaimsLogGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.ElectronicSignature, ElectronicSignatureE.SignatureClaimsLog, true);
        return reslt;
    }
}
@Injectable()
export class RxPickupdetailsGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.ElectronicSignature, ElectronicSignatureE.RxPickupDetails, true);
        return reslt;
    }
}

@Injectable()
export class POSCopayCollectedGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.ElectronicSignature, ElectronicSignatureE.POSCopayCollected, true);
        return reslt;
    }
}
@Injectable()
export class DMSSubcategoryGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.DMS, DMSE.DMSSubcategory, true);
        return reslt;
    }
}
@Injectable()
export class BatchScanGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.DMS, DMSE.BatchScan, true);
        return reslt;
    }
}
@Injectable()
export class DocumentQueueGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.DMS, DMSE.DocumentQueue, true);
        return reslt;
    }
}

@Injectable()
export class PrintRxListWithNoAttachedDocumentsGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.DMS, DMSE.PrintRxListWithNoAttachedDocuments, true);
        return reslt;
    }
}

@Injectable()
export class PrintRxListWithAttachedDocumentsGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.DMS, DMSE.PrintRxListWithAttachedDocuments, true);
        return reslt;
    }
}

@Injectable()
export class LabelDesignGuard extends BasePrivGetter  {
    constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
        super(_userServ, _router, _alertServ);
    }

    canActivate() {
        const reslt = super.validateAuth(AccCategoryE.Label, LabelE.LabelDesigner, true);
        return reslt;
    }
}

// @Injectable()
// export class LabelPrintGuard extends BasePrivGetter implements CanActivate {
//     constructor(_userServ: UserService, _router: Router, _alertServ: AlertService) {
//         super(_userServ, _router, _alertServ);
//     }

//     canActivate() {
//         const reslt = super.validateAuth(AccCategoryE.Label, LabelE.LabelPrintSet, true);
//         return reslt;
//     }
// }
